const CHUNK_RECOVERY_KEY = "tailorbook:chunk-recovery";

export function isChunkLoadError(value: unknown): boolean {
  const message = value instanceof Error ? value.message : typeof value === "string" ? value : "";
  return /dynamically imported module|failed to fetch dynamically imported module|loading chunk|imported module/i.test(message);
}

export function hasAttemptedChunkRecovery(): boolean {
  try {
    return sessionStorage.getItem(CHUNK_RECOVERY_KEY) === "1";
  } catch {
    return false;
  }
}

export function recoverFromChunkLoadError(): void {
  try {
    if (hasAttemptedChunkRecovery()) return;

    sessionStorage.setItem(CHUNK_RECOVERY_KEY, "1");
    window.setTimeout(() => sessionStorage.removeItem(CHUNK_RECOVERY_KEY), 15000);
  } catch {
    // Continue with the normal reload if browser storage is unavailable.
  }

  void (async () => {
    try {
      const registration = await navigator.serviceWorker?.getRegistration();
      await registration?.update();

      if ("caches" in window) {
        const cacheNames = await caches.keys();
        await Promise.all(
          cacheNames
            .filter((name) => /workbox|precache/i.test(name))
            .map((name) => caches.delete(name))
        );
      }
    } finally {
      window.location.reload();
    }
  })();
}
